// theme/ThemeContext.js
import React, { createContext, useContext, useState, useEffect } from 'react';
import AsyncStorage from '@react-native-async-storage/async-storage';

const ThemeContext = createContext();
const THEME_KEY = '@myapp_theme';

export const ThemeProvider = ({ children }) => {
  const [isDarkMode, setIsDarkMode] = useState(false);

  // Charger le thème au démarrage
  useEffect(() => {
    loadTheme();
  }, []);

  // Charger le thème depuis AsyncStorage
  const loadTheme = async () => {
    try {
      const savedTheme = await AsyncStorage.getItem(THEME_KEY);
      if (savedTheme !== null) {
        setIsDarkMode(JSON.parse(savedTheme));
      }
    } catch (error) {
      console.log('Erreur lors du chargement du thème:', error);
    }
  };

  // Sauvegarder le thème dans AsyncStorage
  const saveTheme = async (value) => {
    try {
      await AsyncStorage.setItem(THEME_KEY, JSON.stringify(value));
    } catch (error) {
      console.log('Erreur lors de la sauvegarde du thème:', error);
    }
  };

  const theme = {
    dark: {
      primary: '#165ca2',
      primaryDark: '#1976D2',
      background: '#121212',
      surface: '#1E1E1E',
      text: '#FFFFFF',
      textSecondary: '#B0B0B0',
      border: 'rgba(255, 255, 255, 0.1)',
      card: '#262626',
      icon: '#FFFFFF',
      statusBar: 'light-content',
      success: '#4CAF50',
      danger: '#F44336',
    },
    light: {
      primary: '#165ca2',
      primaryDark: '#1976D2',
      background: '#f8f9fa',
      surface: '#FFFFFF',
      text: '#333333',
      textSecondary: '#666666',
      border: 'rgba(0, 0, 0, 0.1)',
      card: '#FFFFFF',
      icon: '#165ca2',
      statusBar: 'dark-content',
      success: '#4CAF50',
      danger: '#F44336',
    },
  };

  const currentTheme = isDarkMode ? theme.dark : theme.light;

  const toggleTheme = async () => {
    const newMode = !isDarkMode;
    setIsDarkMode(newMode);
    await saveTheme(newMode);
  };

  return (
    <ThemeContext.Provider value={{ theme: currentTheme, isDarkMode, toggleTheme }}>
      {children}
    </ThemeContext.Provider>
  );
};

export const useTheme = () => useContext(ThemeContext);